import type { IControlSelectCompound } from './SelectCompound';
import type { CompoundSelectSettingType } from '../types';

import { PopoverSelectDate } from './PopoverSelectDate';
import { WrapperActivator } from './WrapperActivator';
import { SelectPopover } from '../../SelectPopover';
import { useState, useCallback } from 'react';
import { SelectVariantType } from '../types';
import { getSelectLabel } from '../utils';

export const SelectCompoundContent: React.FC<IControlSelectCompound> = ({ configs, disabled }) => {
  const [activePopovers, setActivePopovers] = useState<boolean[]>(() =>
    new Array(configs?.length ?? 0).fill(false),
  );

  const togglePopover = useCallback(
    (index: number) => {
      setActivePopovers((prev) => {
        const isOpen = !prev[index];

        const onOpenPopover = configs?.[index]?.onOpenPopover;
        if (onOpenPopover) {
          onOpenPopover(isOpen);
        }

        const next = [...prev];
        next[index] = isOpen;
        return next;
      });
    },
    [configs],
  );

  const getPopoverSelect = (config: CompoundSelectSettingType, index: number) => {
    if (config.hide) return null;

    switch (config.variant) {
      case SelectVariantType.CHOICE:
      case SelectVariantType.ACTION_LIST: {
        const { defaultValue, options, isLoading } = config;

        return (
          <div key={index} style={{ minWidth: index === 0 ? 'fit-content' : '0' }}>
            <SelectPopover
              key={index}
              activator={
                <WrapperActivator
                  label={getSelectLabel(defaultValue, options)}
                  onClick={() => togglePopover(index)}
                  disabled={disabled || config.disableActivator}
                  isLoading={isLoading && !defaultValue}
                />
              }
              popoverActive={activePopovers[index]}
              togglePopoverActive={() => togglePopover(index)}
              {...config}
              width={config.width || (config.isShowSearch ? '213px' : '170px')}
            />
          </div>
        );
      }

      case SelectVariantType.DATE:
        return (
          <div key={index} className="[&_*]:min-w-0">
            <PopoverSelectDate disabled={disabled} />
          </div>
        );

      default:
        return null;
    }
  };

  if (!configs?.length) return null;

  return configs.map((config, index) => getPopoverSelect(config, index));
};
